<template>
  <div class="app-shell">
    <header class="app-shell__header">
      <AppMenuBar />
    </header>

    <main class="app-shell__main">
      <router-view />
    </main>

    <footer class="app-shell__footer">
      <span class="app-shell__build">v{{ buildVersion.version }} · {{ shortSha }}<span v-if="buildVersion.timestamp"> · {{ buildVersion.timestamp }}</span></span>
    </footer>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import AppMenuBar from '@/components/AppMenuBar.vue'

// Issue #265 — read the build identity that main.js installed on window.
// Computed defends against the global being absent (SSR, tests, manual mount).
const buildVersion = computed(() => {
  const installed = typeof window !== 'undefined' ? window.__BUILD_VERSION__ : undefined
  if (installed && typeof installed === 'object') {
    return installed
  }
  return { sha: 'dev', timestamp: '', version: '0.0.0' }
})
const shortSha = computed(() => {
  const sha = buildVersion.value.sha
  return sha.length > 12 ? sha.slice(0, 12) : sha
})
</script>
